module.exports = __webpack_public_path__ + "static/media/12-3.2afc533f.mp3";